//import stylesConfig from "theme/config";

const styles = {};

export default styles;
